module.exports = __webpack_public_path__ + "static/sponsor-036b25a1b6d9e894756a7fac6be5ac45.png";